import React, { useState, useRef, useEffect } from 'react';
import { AlertTriangle, Clock, XCircle, Wifi, WifiOff } from 'lucide-react';
import Countdown, { zeroPad } from 'react-countdown';
import StreamWebService from '../classes/StreamWebService';
import './InteruptionConfirmer.css';

export default function InteruptionConfirmer({ callback, item }) {
    const counter = useRef();
    const [countTime, setCountTime] = useState(Date.now() + 300000); // 5 minutes
    const [isEnding, setIsEnding] = useState(false);

    const handleSubmit = async () => {
        setIsEnding(true);
        try {
            const wb = new StreamWebService();
            await wb.confirmStop(item.id);
            callback();
        } catch (error) {
            console.error("Failed to end session:", error);
            setIsEnding(false);
        }
    };

    useEffect(() => {
        // Component mount logic if needed
    }, []);

    return (
        <div className="interruption-container">
            {/* Warning Icon */}
            <div className="interruption-icon-wrapper">
                <div className="interruption-icon-bg">
                    <WifiOff className="interruption-icon" size={32} strokeWidth={2} />
                </div>
            </div>

            {/* Title */}
            <h2 className="interruption-title">
                Stream Interrupted
            </h2>

            {/* Description */}
            <div className="interruption-description">
                <p>
                    Your stream connection has been interrupted. The session will be automatically
                    terminated after the countdown completes.
                </p>
                <p className="interruption-help-text">
                    If this is due to technical issues, please reconnect before the timer expires
                    to resume your stream.
                </p>
            </div>

            {/* Countdown Timer */}
            <div className="interruption-countdown">
                <div className="countdown-icon">
                    <Clock size={20} strokeWidth={2} />
                </div>
                <div className="countdown-time">
                    <Countdown
                        ref={counter}
                        date={countTime}
                        autoStart
                        onComplete={handleSubmit}
                        renderer={({ minutes, seconds }) => {
                            const isWarning = minutes < 1; // Last minute warning
                            return (
                                <span className={`countdown-digits ${isWarning ? 'countdown-warning' : ''}`}>
                                    {zeroPad(minutes)}:{zeroPad(seconds)}
                                </span>
                            );
                        }}
                    />
                </div>
            </div>

            {/* Action Buttons */}
            <div className="interruption-actions">
               

                <button
                    className="interruption-btn reconnect-btn"
                    onClick={handleSubmit}
                    disabled={isEnding}
                >
                    {isEnding ? (
                        <>
                            <div className="spinner-small"></div>
                            <span>Ending...</span>
                        </>
                    ) : (
                        <>
                            <XCircle size={18} strokeWidth={2} />
                            <span>Yes! End Stream</span>
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}
